
webpack.register(
    'components/video-landing/live-video-right-rail/live-video-right-rail-leaderboard/leaderboard-mini/leaderboard-mini',
    function() {
        return require('components/video-landing/live-video-right-rail/live-video-right-rail-leaderboard/leaderboard-mini/leaderboard-mini');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/video-landing/live-video-right-rail/live-video-right-rail-leaderboard/leaderboard-mini/leaderboard-mini'/>\r\n\r\n<div class=\"s-right-rail-leaderboard {{#is activeTab 'leaderboard'}}is-selected{{/is}}\">\r\n\r\n    <leaderboard-mini (fav-toggled)=\"favToggled\" {(standings)}=\"standings\" {(favorites)}=\"favorites\" {short}=\"short\" {is-live}=\"true\"></leaderboard-mini>\r\n\r\n</div>");